import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import { usePage } from "@inertiajs/react"
import type { GiselaTherapist, PageProps } from "@/types/inertia"

// The CBT / EMDR / closing blocks from her Therapist record. Rendered as the
// inner column only, so the home page and About Me can each wrap it in their
// own section chrome. Returns null when she has written none of it.
export function TherapistApproach({ therapist }: { therapist: GiselaTherapist }) {
  const tp = usePage<PageProps>().props.translations.gisela_pages.profile

  if (!therapist.approach_cbt && !therapist.approach_emdr && !therapist.approach_closing) {
    return null
  }

  return (
    <>
      {therapist.approach_cbt && (
        <div className="mt-8">
          <h3>{tp.cbt_heading}</h3>
          <div className="body-content mt-4 text-ink-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{therapist.approach_cbt}</ReactMarkdown>
          </div>
        </div>
      )}

      {therapist.approach_emdr && (
        <div className="mt-8">
          <h3>{tp.emdr_heading}</h3>
          <div className="body-content mt-4 text-ink-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{therapist.approach_emdr}</ReactMarkdown>
          </div>
        </div>
      )}

      {therapist.approach_closing && (
        <div className="mt-8 rounded-2xl bg-white p-6 ring-1 ring-hairline">
          <div className="body-content text-ink-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{therapist.approach_closing}</ReactMarkdown>
          </div>
        </div>
      )}
    </>
  )
}
